import { render } from "./UnitsView.vue?vue&type=template&id=cb67a83c&ts=true"
import script from "./UnitsView.vue?vue&type=script&lang=ts"
export * from "./UnitsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__